import { useEffect, useState } from "react";

import { api } from "@/api";

// Panneau Filtres : départements à cocher (présents dans les fiches) + recherche par ville ou code postal
export const PlaceFilter = ({ filters, set }) => {
  const [deps, setDeps] = useState(null);
  const [all, setAll] = useState(false);
  const [city, setCity] = useState(filters.city || "");
  useEffect(() => {
    api.get("/pipeline/departments", { params: { pipeline: filters.pipeline || "", show_archived: filters.show_archived } }).then(({ data }) => setDeps(data)).catch(() => setDeps({ departments: [], without: 0 }));
  }, [filters.pipeline, filters.show_archived]);
  useEffect(() => { const t = setTimeout(() => { if (city !== (filters.city || "")) set({ city }); }, 400); return () => clearTimeout(t); }, [city]); // eslint-disable-line react-hooks/exhaustive-deps
  const list = (deps?.departments || []).slice().sort((a, b) => filters.depts.includes(b.code) - filters.depts.includes(a.code));
  const shown = all ? list : list.slice(0, 12);
  const flip = (code) => set({ depts: filters.depts.includes(code) ? filters.depts.filter((c) => c !== code) : [...filters.depts, code] });
  return (
    <div className="pl-place" data-testid="filter-place">
      <input className="pl-select" placeholder="Ville ou code postal…" value={city} onChange={(e) => setCity(e.target.value)} data-testid="filter-city-input" />
      {deps === null ? <p className="pl-muted">Chargement des départements…</p> : (
        <>
          <div className="pl-place__list">{shown.map((d) => (
            <label key={d.code} className={`pl-place__dep${filters.depts.includes(d.code) ? " is-on" : ""}`} data-testid={`filter-dept-${d.code}`}>
              <input type="checkbox" checked={filters.depts.includes(d.code)} onChange={() => flip(d.code)} />
              <b>{d.code}</b> {d.name} <em>{d.count}</em>
            </label>
          ))}</div>
          {list.length > 12 && <button type="button" className="pl-link" onClick={() => setAll(!all)} data-testid="filter-dept-more">{all ? "Réduire" : `Voir les ${list.length} départements`}</button>}
          {deps.without > 0 && <p className="pl-muted">{deps.without} fiches sans code postal connu ne sont rattachées à aucun département.</p>}
        </>
      )}
    </div>
  );
};
